import React, { useState } from "react";
import FilterIcon from "./FilterIcon";
import CategoryIcon from "./CategoryIcon";

function FilterButtons({
  filters,
  labels,

  taxonomy,
  handleFilterChange,
  activeFilters,
  type,
}) {
  const [show, setShow] = useState(false);
  return (
    <>
      {Object.keys(filters[type]).map(function (subKey) {
        if (true == true) {
          return (
            <div className="button_su su_inverted large-button v-mb-3 v-mr-3  " key={"key_" + type + "_" + subKey}>
              <div className="su_button_circle"></div>

              <div
                className={
                  "hover-effect v-ease-in-out v-cursor-pointer v-duration-300 button_su_inner v-transition  hover:v-text-white v-whitespace-nowrap  v-inline-flex v-items-center v-justify-between   v-rounded-full v-px-4 v-py-2 v-text-body v-font-semibold  " +
                  (activeFilters[type].includes(filters[type][subKey]["id"])
                    ? "v-bg-primary v-text-white"
                    : "v-bg-white  v-text-primary")
                }
                onClick={() =>
                  handleFilterChange(type, filters[type][subKey]["id"])
                }
              >
                <div className="v-relative v-z-100">
                  {filters[type][subKey]["label"]}
                </div>
              </div>
            </div>
          );
        }
      })}
    </>
  );
}

export default FilterButtons;
